import '../../style/base.css';
import '../../loading/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/picker/style/index.js
// module id = 169
// module chunks = 0